import Model from "../../model"
import { ID, FleetingIdea } from "../../types"

import Command, { CommandName } from "../command"
import DeleteFleetingIdeaCommand from "./delete_fleeting_idea_command"

export type CreateFleetingIdeaCommandState = {
  id: ID
  fleetingIdea: FleetingIdea
}

export default class CreateFleetingIdeaCommand extends Command {
  name: CommandName = "create-fleeting-idea"
  state: CreateFleetingIdeaCommandState

  constructor(state: CreateFleetingIdeaCommandState) {
    super()
    this.state = state
  }

  // Possible conflicts:
  //   - none
  resolveConflicts(model: Model): CreateFleetingIdeaCommandState {
    return this.state
  }

  local(model: Model): any {
    model.createFleetingIdea(this.state.id, this.state.fleetingIdea)
  }

  undo(): Command[] {
    return [new DeleteFleetingIdeaCommand({ id: this.state.id })]
  }
}
